/**
 * Auth V2 — opening a catalog URL is navigate-only; backend auto-engages on first touch.
 *
 * Call sites: Favorites, ShopsDirectoryScreen, cart chrome, BottomNav Nákupy.
 */

import { isReservedCustomerPathSegment } from '../auth/customerAuthPaths.js';
import { isPlatformChromeTenant } from '../../app/platformChromeTenant.js';

export type DirectoryShopOpenAction =
  | { readonly kind: 'navigate'; readonly url: string };

/**
 * First path segment of an in-app href (`/{tenant}/{slug}` or `/{tenant}/shop?kioskId=`).
 */
export function tenantCodeFromAppHref(href: string): string {
  const pathOnly = href.trim().split(/[?#]/, 1)[0] ?? '';
  const segment = pathOnly.split('/').filter((s) => s.length > 0)[0];
  if (segment === undefined) {
    return '';
  }
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}

export function resolveDirectoryShopOpenAction(input: {
  readonly customerShopUrl: string;
  readonly targetTenantCode: string;
}): DirectoryShopOpenAction | null {
  if (input.customerShopUrl.length === 0) {
    return null;
  }

  const target = input.targetTenantCode.trim();

  if (
    target.length === 0 ||
    isPlatformChromeTenant(target) ||
    isReservedCustomerPathSegment(target)
  ) {
    return { kind: 'navigate', url: input.customerShopUrl };
  }

  return { kind: 'navigate', url: input.customerShopUrl };
}
